import { t } from "@/i18n-js/instance";
import type { ComponentMeta } from "@circle-react-shared/BuilderUI/BuilderUI.types";

export const getBlockName = (meta: ComponentMeta) => {
  const i18nKey = meta.nameI18n;
  const fallbackName = meta.name;
  return i18nKey ? t(i18nKey, { defaultValue: fallbackName }) : fallbackName;
};
